// extracted by mini-css-extract-plugin
export default {"chip":"chip-feature_chip__wD+uJ"};